import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Activation from './pages/Activation';
import ThankYou from './pages/ThankYou';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/activate" element={<Activation />} />
          <Route path="/activation" element={<Activation />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/terms-and-conditions.html" element={<TermsAndConditions />} />
          <Route path="/terms-and-conditions.php" element={<TermsAndConditions />} />
          <Route path="/activate/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/activate/terms-and-conditions.html" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/privacy-policy.html" element={<PrivacyPolicy />} />
          <Route path="/privacy-policy.php" element={<PrivacyPolicy />} />
          <Route path="/activate/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/activate/privacy-policy.html" element={<PrivacyPolicy />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/thank-you.html" element={<ThankYou />} />
          <Route path="/thank-you.php" element={<ThankYou />} />
          <Route path="/activate/thank-you" element={<ThankYou />} />
          <Route path="/activate/thank-you.html" element={<ThankYou />} />
          <Route path="/activate/thank-you.php" element={<ThankYou />} />
          <Route path="/activation/thank-you" element={<ThankYou />} />
          <Route path="/activation/thank-you.html" element={<ThankYou />} />
          <Route path="/activation/thank-you.php" element={<ThankYou />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
